import { UserRole } from "../constants";
import MainCreateAdvance from "./MainCreateAdvance";
import SubAdministratorCreateAdvance from "./SubAdministratorCreateAdvance";

/**
 * New advance form
 */
export default function CreateAdvance() {
  const role = localStorage.getItem("role");
  if (role === UserRole.SUB_ADMINISTRATOR) {
    return <SubAdministratorCreateAdvance />;
  }
  return <MainCreateAdvance />;
}
